import React from "react";
import {
  MessageCircle, Hand, Smile, BookOpen, Activity, Puzzle, Sparkles, Zap, ArrowUpRight,
} from "lucide-react";
import { services } from "../mock";

const ICONS = { MessageCircle, Hand, Smile, BookOpen, Activity, Puzzle, Sparkles, Zap };

export default function Services() {
  return (
    <section id="services" className="py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl reveal">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-orange-50 text-[#ee6c4d] text-xs font-semibold tracking-[0.2em] uppercase">
            Our Services
          </div>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl md:text-5xl text-[#122b45] leading-tight">
            Therapy designed around <span className="text-[#ee6c4d]">your child.</span>
          </h2>
          <p className="mt-4 text-slate-600 leading-relaxed text-sm sm:text-base">
            From speech and sensory work to behaviour and learning — our specialists collaborate to build a path forward that&apos;s joyful, structured and effective.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((s, idx) => {
            const Icon = ICONS[s.icon];
            return (
              <a
                key={s.title}
                href="#contact"
                onClick={(e) => { e.preventDefault(); document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" }); }}
                className={`svc-card group bg-white rounded-2xl p-6 border border-orange-100/70 relative block reveal reveal-delay-${((idx % 4) + 1) * 100}`}
              >
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${s.color}`}>
                  {Icon && <Icon className="w-6 h-6" />}
                </div>
                <h3 className="mt-5 font-semibold text-lg text-[#122b45]">{s.title}</h3>
                <p className="mt-2 text-sm text-slate-500 leading-relaxed">{s.desc}</p>
                <ArrowUpRight className="absolute top-6 right-6 w-5 h-5 text-slate-300 group-hover:text-[#ee6c4d] group-hover:rotate-12 transition" />
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
